import Icon from "@mui/material/Icon";
import Dashboard from "layouts/dashboard";
import VendorCategory from "layouts/tables/admin/vendor_categories"
import VendorAdminProducts from "layouts/tables/admin/vendor_products";
import Vendororders from "layouts/tables/admin/vendor_order_details";
import Approve from "layouts/tables/admin/vendor_approve";
import SalesReport from "layouts/tables/Reports/sales_report";
import AutoVendorApproval from "layouts/tables/admin/settings/autovendorapproval";

import VendorRegister from "layouts/tables/admin/vendor_register/vendor_register";
import Banner from "layouts/tables/admin/banner_content"
import ColorSelectionPage from "layouts/tables/admin/color_selection/color_selection"
import ServiceType from "layouts/tables/admin/services_type/ServiceType";
import ServiceRegistration from "layouts/tables/admin/service_register/service_registration";
import ServiceApprove from "layouts/tables/admin/service_approve/service_approve";
import AdminRegister from "layouts/tables/admin/admin_register/admin_register";
import AdminControls from "layouts/tables/admin/admin_controls/admin_controls";
import TermsAndConditions from "layouts/tables/admin/termsandconditions/termsandconditions";
import VendorControls from "layouts/tables/admin/vendor_controls/vendor_controls";
import ServiceControls from "layouts/tables/admin/service_controls/service_controls";
import BusinessCategory from "layouts/tables/admin/business_category/business_category";
import InactiveVendors from "layouts/tables/admin/inactive_vendors/inactive_vendors";
import AdminReferral from "layouts/tables/admin/admin-referral/admin-referral";
import AppCategory from "layouts/tables/admin/app_category/app_category";
import BusinessAdsPage from 'layouts/tables/admin/business_ads/businessads';
import PaymentPlansPage from "layouts/tables/admin/payment_plans/payment_plan_page";
import FeedbackViewPage from "layouts/tables/admin/complaints/user_complaints";
import CouponManagement from 'layouts/tables/admin/coupons/coupons';
import IncentiveManagement from "layouts/tables/admin/incentive/incentive_management";
import MarketingManagerControls from "layouts/tables/admin/admin_controls/marketing_manager_controls";
import TelecallerControls from "layouts/tables/admin/admin_controls/telecaller_controls";
import VerifyVendors from "layouts/tables/admin/vendor_approve/verify_vendors";
import VerifyServiceProviders from "layouts/tables/admin/service_approve/verify_serviceprovider";

const routesSuperAdmin = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: <Dashboard />,
  },
  {
    type: "collapse",
    name: "Admin Management",
    key: "admin-management",
    icon: <Icon fontSize="small">shield_person</Icon>,
    children: [
      {
        type: "collapse",
        name: "Admin/Staff Register",
        key: "admin_register",
        icon: <Icon fontSize="small">app_registration</Icon>,
        route: "/admin_register",
        component: <AdminRegister />,
      },
      {
        type: "collapse",
        name: "Admin Controls",
        key: "admin controls",
        icon: <Icon fontSize="small">tune</Icon>,
        route: "/admin_controls",
        component: <AdminControls />,
      },
      {
        type: "collapse",
        name: "Marketing Manager Controls",
        key: "marketing manager controls",
        icon: <Icon fontSize="small">tune</Icon>,
        route: "/marketing_manager_controls",
        component: <MarketingManagerControls />,
      },
      {
        type: "collapse",
        name: "Telecaller Controls",
        key: "telecaller manager controls",
        icon: <Icon fontSize="small">tune</Icon>,
        route: "/telecaller_controls",
        component: <TelecallerControls />,
      },
      {
        type: "collapse",
        name: "Vendor Controls",
        key: "vendor controls",
        icon: <Icon fontSize="small">tune</Icon>,
        route: "/vendor_controls",
        component: <VendorControls />,
      },
      {
        type: "collapse",
        name: "Service Controls",
        key: "service controls",
        icon: <Icon fontSize="small">tune</Icon>,
        route: "/service_controls",
        component: <ServiceControls />,
      },

    ],
  },
  {
    type: "collapse",
    name: "App Management",
    key: "app-management",
    icon: <Icon fontSize="small">smartphone</Icon>,  // less crisp than SVG
    children: [
      {
        type: "collapse",
        name: "App Category",
        key: "app_category",
        icon: <Icon fontSize="small">category</Icon>,
        route: "/app_management/app_category",
        component: <AppCategory />,
      },
      {
        type: "collapse",
        name: "User Complaints",
        key: "complaints",
        icon: <Icon fontSize="small">feedback</Icon>,
        route: "/complaints",
        component: <FeedbackViewPage />,
      },
    ],
  },

  {
    type: "collapse",
    name: "Vendor Management",
    key: "vendor-management",
    icon: <Icon fontSize="small">storefront</Icon>,
    children: [
      {
        type: "collapse",
        name: "Registration",
        key: "registration",
        icon: <Icon fontSize="small">app_registration</Icon>,
        route: "/vendor_management/Registration",
        component: <VendorRegister />,
      },

      {
        type: "collapse",
        name: "Vendor Approve",
        key: "approve vendor",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/vendor_management/Approve_Request",
        component: <Approve />,
      },
      {
        type: "collapse",
        name: "Unverified Vendors",
        key: "vendor_unverified",
        icon: <Icon fontSize="small">fact_check</Icon>,
        route: "/admin/vendors/unverified",
        component: <VerifyVendors />,
      },
      {
        type: "collapse",
        name: "Vendor Status",
        key: "inactive vendors",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/vendor_management/Inactive_Vendors",
        component: <InactiveVendors />,
      },
      {
        type: "collapse",
        name: "Business Category",
        key: "business category",
        icon: <Icon fontSize="small">business_center</Icon>,
        route: "/vendor_management/business_category",
        component: <BusinessCategory />,
      },
      {
        type: "collapse",
        name: "Vendor Products",
        key: "vendor products",
        icon: <Icon fontSize="small">inventory_2</Icon>,
        route: "/vendor_management/Vendor_Products",
        component: <VendorAdminProducts />,
      },
      {
        type: "collapse",
        name: "Vendor Categories",
        key: "vendor categories",
        icon: <Icon fontSize="small">category_search</Icon>,
        route: "/vendor_management/Vendor_Categories",
        component: <VendorCategory />,
      },
      {
        type: "collapse",
        name: "Vendor Orders",
        key: "approve vendor",
        icon: <Icon fontSize="small">reorder</Icon>,
        route: "/vendor_management/Order_Details",
        component: <Vendororders />,
      },


    ],
  },
  {
    type: "collapse",
    name: "Service Management",
    key: "service-management",
    icon: <Icon fontSize="small">local_mall</Icon>,
    children: [
      {
        type: "collapse",
        name: "Registration",
        key: "registration",
        icon: <Icon fontSize="small">app_registration</Icon>,
        route: "/service_management/Registration",
        component: <ServiceRegistration />,
      },
      {
        type: "collapse",
        name: "Service Approve",
        key: "service_approve",
        icon: <Icon fontSize="small">verified</Icon>,
        route: "/service_management/service_approve",
        component: <ServiceApprove />,
      },
      {
  type: "collapse",
  name: "Unverified Services",
  key: "service_unverified",
  icon: <Icon fontSize="small">fact_check</Icon>,
  route: "/admin/services/unverified",
  component: <VerifyServiceProviders />,
},

      {
        type: "collapse",
        name: "Service Type",
        key: "service_type",
        // icon: <Icon fontSize="small">Service Type</Icon>,
        icon: <Icon fontSize="small">category</Icon>,
        route: "/service_management/service_type",
        component: <ServiceType />,
      },
      {
        type: "collapse",
        name: "Service Specialization",
        key: "service_specialization",
        // icon: <Icon fontSize="small">Service Specialization</Icon>,
        icon: <Icon fontSize="small">apps</Icon>,
        route: "/service_management/service_specialization",
        component: <ServiceType />,
      },


    ],
  },
  {
    type: "collapse",
    name: "Reports and Analyzes",
    key: "report-management",
    icon: <Icon fontSize="small">monitoring</Icon>,
    children: [
      {
        type: "collapse",
        name: "Sales Report",
        key: "admin_sales_report",
        icon: <Icon fontSize="small">bar_chart</Icon>,
        route: "/report_management/sales_reports",
        component: <SalesReport />,

      },

      {
        type: "collapse",
        name: "Admin Referrals",
        key: "admin_referrals",
        icon: <Icon fontSize="small"> group</Icon>,
        route: "/admin_referrals",
        component: <AdminReferral />,
      },
    ]
  },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications_icon</Icon>,
  //   route: "/admins/notifications",
  //   component: <VendorNotifications />,
  // },
  {
    type: "collapse",
    name: "Business Advertisement",
    key: "business ads",
    icon: <Icon fontSize="small">campaign_icon</Icon>,
    route: "/businessads",
    component: <BusinessAdsPage />,
  },
  {
    type: "collapse",
    name: "Payment Plans",
    key: "payment plans",
    icon: <Icon fontSize="small">payment</Icon>,
    route: "/admin/Payment_Plans",
    component: <PaymentPlansPage />,
  },
  {
    type: "collapse",
    name: "Coupon Management",
    key: "coupon management",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/admin/Coupons",
    component: <CouponManagement />,
  },
  {
    type: "collapse",
    name: "App Color Management",
    key: "appcolor management",
    icon: <Icon fontSize="small">local_offer</Icon>,
    route: "/admin/Appcolormanagement",
    component: <ColorSelectionPage />,
  },
  {
    type: "collapse",
    name: "Incentive Management",
    key: "incentive management",
    icon: <Icon fontSize="small">card_giftcard</Icon>,
    route: "/admin/Incentive",
    component: <IncentiveManagement />,
  },
  {
    type: "collapse",
    name: "Settings",
    key: "Settings",
    icon: <Icon fontSize="small">settings</Icon>,
    children: [
      {
        type: "collapse",
        name: "Auto Vendor Approval",
        key: "auto_vendor_approval",
        icon: <Icon fontSize="small">toggle_on</Icon>,
        route: "/admin/settings/auto-vendor-approval",
        component: <AutoVendorApproval />,
      },
      {
        type: "collapse",
        name: "Terms & Conditions",
        key: "terms",
        icon: <Icon fontSize="small">description</Icon>,
        route: "/admins/terms_and_conditions",
        component: <TermsAndConditions />,
      },
    ],
  },

];

export default routesSuperAdmin;
